import { render, staticRenderFns } from "./Konto.vue?vue&type=template&id=0db47001&scoped=true"
import script from "./Konto.vue?vue&type=script&lang=js"
export * from "./Konto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db47001",
  null
  
)

export default component.exports